var exports = {
  "x6": "AddGuildButton.module__button___blk2Yz",
  "td": "AddGuildButton.module__iconText___blk2Yz",
  "ro": "AddGuildButton.module__menuIcon___blk2Yz",
};

module.exports = exports;
